import { render, staticRenderFns } from "./GoodsTable.vue?vue&type=template&id=5cddd2d3&scoped=true&"
import script from "./GoodsTable.vue?vue&type=script&lang=js&"
export * from "./GoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTable.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./GoodsTable.vue?vue&type=style&index=1&id=5cddd2d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cddd2d3",
  null
  
)

export default component.exports